var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
/* eslint-disable */
import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { setDrawerOpen } from 'reducers/Layout/action';
import { getUserDataRedux } from 'reducers/Login/selector';
import { getDrawerOpen } from 'reducers/Layout/selector';
import Axios from 'axios';
import { PopupTitle } from 'component/title/Title';
import TipsPassword from 'component/tips/Tips';
import { StyledButtonConfirm, StyledButtonCancel, } from 'component/material/StyledButton';
import { customlog } from 'component/utility/CustomLog';
import IconButton from '@material-ui/core/IconButton';
import HomeOutlinedIcon from '@material-ui/icons/HomeOutlined';
import ExitToAppOutlinedIcon from '@material-ui/icons/ExitToAppOutlined';
import Hidden from '@material-ui/core/Hidden';
import MenuIcon from '@material-ui/icons/Menu';
import Popover from '@material-ui/core/Popover';
import CloseIcon from '@material-ui/icons/Close';
import { withStyles } from '@material-ui/core';
import GridList from '@material-ui/core/GridList';
import GridListTile from '@material-ui/core/GridListTile';
import HelpIcon from '@material-ui/icons/Help';
import Tooltip from '@material-ui/core/Tooltip';
import { NavLink } from 'react-router-dom';
import Logo from 'asset/inc/img/global/logo.png';
import { withSnackbar } from 'notistack';
import { APP_PATH } from 'config';
import { Input } from '@progress/kendo-react-inputs';
import ConnectionTime from './ConnectionTime';
// eslint-disable-next-line @typescript-eslint/no-var-requires
var Style = require('./titleandtool_style.module.css');
var StyledPopover = withStyles({
    paper: {
        width: '500px',
        maxWidth: 'none',
    },
})(Popover);
var StyleIconButton = withStyles({
    root: {
        position: 'absolute',
        right: '12px',
    },
})(IconButton);
var StyledGridList = withStyles({
    root: {},
})(GridList);
var StyledTitleGridListTile = withStyles({
    root: {
        // border: '1px solid #ddd',
        // backgroundColor: '#efefef',
        paddingRight: '5px',
    },
    tile: {
        textAlign: 'right',
        paddingRight: '5px',
        // backgroundColor: '#efefef',
        fontWeight: 'bold',
    },
})(GridListTile);
var StyledGridListTile = withStyles({
    root: {
    // border: '1px solid #ddd',
    },
    tile: {
        paddingLeft: '5px',
    },
})(GridListTile);
export var ChangePassword = function (props) {
    var open = props.open, daysBeforeInterval = props.daysBeforeInterval, passwordDuplicate = props.passwordDuplicate, username = props.username, passwordOld = props.passwordOld, passwordNew = props.passwordNew, form = props.form, passwordNewConfirm = props.passwordNewConfirm, confirmStatus = props.confirmStatus, handleChangePwClose = props.handleChangePwClose, handleFormSubmit = props.handleFormSubmit, handleInputBlur = props.handleInputBlur;
    var disableClose = daysBeforeInterval === -1 ? (React.createElement(StyleIconButton, { onClick: handleChangePwClose },
        React.createElement(CloseIcon, null))) : (React.createElement("div", { style: { height: 0, width: 0 } }));
    var duplicateError = passwordDuplicate ? (React.createElement("div", { style: { width: '100%', color: 'red', textAlign: 'center' } }, "\u65B0\u5BC6\u78BC\u4E0D\u80FD\u8207\u820A\u5BC6\u78BC\u76F8\u540C")) : (React.createElement("div", { style: { height: 0, width: 0 } }));
    var pwdIntervalWarning = React.createElement("div", { style: { height: 0, width: 0 } });
    if (daysBeforeInterval !== -1) {
        pwdIntervalWarning = (React.createElement(StyledGridListTile, { cols: 3 },
            React.createElement("div", { style: { color: 'red', textAlign: 'center', fontSize: '20px' } },
                "\u5BC6\u78BC\u5C07\u65BC",
                daysBeforeInterval,
                "\u65E5\u5167\u5230\u671F")));
    }
    if (daysBeforeInterval < -1) {
        pwdIntervalWarning = (React.createElement(StyledGridListTile, { cols: 3 },
            React.createElement("div", { style: { color: 'red', textAlign: 'center', fontSize: '20px' } }, "\u5BC6\u78BC\u5DF2\u903E\u671F")));
    }
    return (React.createElement(StyledPopover, { open: open, style: { background: 'rgba(0, 0, 0, 0.4)' }, anchorOrigin: {
            vertical: 'bottom',
            horizontal: 'center',
        }, transformOrigin: {
            vertical: 'center',
            horizontal: 'center',
        } },
        React.createElement("div", { className: Style.listitem },
            React.createElement(PopupTitle, { title: "\u4FEE\u6539\u5BC6\u78BC" }),
            disableClose),
        React.createElement("form", { ref: form },
            React.createElement("div", { className: Style.popup_content },
                duplicateError,
                React.createElement(StyledGridList, { cols: 3, cellHeight: 56 },
                    React.createElement(StyledTitleGridListTile, { cols: 1 },
                        React.createElement("p", null, "\u5E33\u865F")),
                    React.createElement(StyledGridListTile, { cols: 2 },
                        React.createElement("p", null, username)),
                    React.createElement(StyledTitleGridListTile, { cols: 1 },
                        React.createElement("p", null, "\u76EE\u524D\u5BC6\u78BC")),
                    React.createElement(StyledGridListTile, { cols: 2 },
                        React.createElement(Input, { name: "passwordOld", value: passwordOld, type: "password", className: Style.input, pattern: "^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,}$", maxLength: 64, required: true, validationMessage: "\u6B64\u70BA\u5FC5\u586B\uFF0C\u8ACB\u8F38\u5165\u4E0D\u8D85\u904E64\u5B57\u5143\u4E26\u7B26\u5408\u5BC6\u78BC\u683C\u5F0F\u8981\u6C42\u7684\u5167\u5BB9", onChange: handleInputBlur('passwordOld') })),
                    React.createElement(StyledTitleGridListTile, { cols: 1 },
                        React.createElement("p", null,
                            "\u65B0\u5BC6\u78BC",
                            React.createElement("div", { style: {
                                    paddingTop: '1px',
                                    float: 'right',
                                } },
                                React.createElement(Tooltip, { title: TipsPassword },
                                    React.createElement(HelpIcon, { fontSize: "small" }))))),
                    React.createElement(StyledGridListTile, { cols: 2 },
                        React.createElement(Input, { name: "passwordNew", value: passwordNew, type: "password", className: Style.input, pattern: "^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,}$", maxLength: 64, required: true, validationMessage: "\u6B64\u70BA\u5FC5\u586B\uFF0C\u8ACB\u8F38\u5165\u4E0D\u8D85\u904E64\u5B57\u5143\u4E26\u7B26\u5408\u5BC6\u78BC\u683C\u5F0F\u8981\u6C42\u7684\u5167\u5BB9", onChange: handleInputBlur('passwordNew') })),
                    React.createElement(StyledTitleGridListTile, { cols: 1 },
                        React.createElement("p", null, "\u78BA\u8A8D\u65B0\u5BC6\u78BC")),
                    React.createElement(StyledGridListTile, { cols: 2 },
                        React.createElement(Input, { name: "passwordNewConfirm", value: passwordNewConfirm, type: "password", className: Style.input, pattern: "^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z]).{8,}$", maxLength: 64, required: true, validationMessage: "\u6B64\u70BA\u5FC5\u586B\uFF0C\u8ACB\u8F38\u5165\u4E0D\u8D85\u904E64\u5B57\u5143\u4E26\u7B26\u5408\u5BC6\u78BC\u683C\u5F0F\u8981\u6C42\u7684\u5167\u5BB9", onChange: handleInputBlur('passwordNewConfirm') })),
                    pwdIntervalWarning),
                React.createElement("div", { className: Style.detail_function_button_area },
                    React.createElement(StyledButtonConfirm, { onClick: handleFormSubmit(), disabled: !confirmStatus }, "\u78BA\u8A8D"),
                    React.createElement("div", { style: { width: '15px' } }),
                    React.createElement(StyledButtonCancel, { onClick: handleChangePwClose, disabled: daysBeforeInterval !== -1 }, "\u95DC\u9589"))))));
};
var TitleandTool = /** @class */ (function (_super) {
    __extends(TitleandTool, _super);
    function TitleandTool() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            anchorEl: null,
            changePwOpen: _this.props.pwNeedChange,
            username: '',
            passwordOld: '',
            passwordNew: '',
            passwordNewConfirm: '',
            passwordDuplicate: false,
            confirmStatus: false,
        };
        // 定位表單
        _this.form = React.createRef();
        _this.handleDrawerOpen = function () {
            // console.log("drawerOpen");
            _this.props.actions.setDrawerOpen(_this.props.drawerOpen);
        };
        _this.handleClick = function () {
            // LogWrite(this.props.jwtData, this.props.username, "", "登出");
            window.sessionStorage.clear();
            // console.log("logout");
        };
        // public handleUserClick = () => event => {
        //     this.setState({ anchorEl: event.currentTarget });
        // };
        // public handleChangePwClick = () => {
        //     this.setState({
        //         changePwOpen: true,
        //     });
        //     this.handleClose();
        // }
        _this.handleChangePwClose = function () {
            _this.setState({
                changePwOpen: false,
                username: '',
                passwordOld: '',
                passwordNew: '',
                passwordNewConfirm: '',
                confirmStatus: false,
            });
        };
        // public handleClose = () => {
        //     this.setState({ anchorEl: null });
        // };
        _this.handleInputBlur = function (name) { return function (event) {
            var _a;
            _this.setState((_a = {},
                _a[name] = event.target.value,
                _a.username = _this.props.username,
                _a));
        }; };
        /**
         * Usage: 儲存處理函式，先檢查表單的資料合法性再送出表單
         * Param: none
         * As Callback: <Taskbar />
         */
        _this.handleFormSubmit = function () { return function (event) {
            if (_this.form.current !== null) {
                if (_this.form.current.reportValidity()) {
                    _this.handleSubmitClick();
                }
            }
        }; };
        _this.handleSubmitClick = function () { return __awaiter(_this, void 0, void 0, function () {
            var th, enqueueSnackbar, response, error_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.state.passwordOld === this.state.passwordNew) {
                            this.setState({ passwordDuplicate: true });
                            return [2 /*return*/];
                        }
                        th = this;
                        enqueueSnackbar = this.props.enqueueSnackbar;
                        _a.label = 1;
                    case 1:
                        _a.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, Axios.post(process.env.REACT_APP_API_SERVER + "userdata/updatepw", {
                                userId: this.props.username,
                                userPassword: this.state.passwordOld,
                                userPasswordNew: this.state.passwordNew,
                            })];
                    case 2:
                        response = _a.sent();
                        customlog('TitleandTool handleSubmitClick response: ', response);
                        enqueueSnackbar(response.data.msg);
                        th.handleChangePwClose();
                        return [3 /*break*/, 4];
                    case 3:
                        error_1 = _a.sent();
                        customlog('TitleandTool handleSubmitClick error: ', error_1);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                }
            });
        }); };
        return _this;
    }
    TitleandTool.prototype.componentDidUpdate = function () {
        if (this.state.passwordNew === this.state.passwordNewConfirm &&
            this.state.passwordNew !== '' &&
            this.state.passwordNewConfirm !== '') {
            if (this.state.confirmStatus !== true) {
                this.setState({ confirmStatus: true });
            }
        }
        else if (this.state.confirmStatus !== false) {
            this.setState({ confirmStatus: false });
        }
    };
    TitleandTool.prototype.render = function () {
        var anchorEl = this.state.anchorEl;
        return (React.createElement("div", { className: "header" },
            this.state.changePwOpen && (React.createElement(ChangePassword, { username: this.props.username, passwordOld: this.state.passwordOld, passwordNew: this.state.passwordNew, passwordNewConfirm: this.state.passwordNewConfirm, passwordDuplicate: this.state.passwordDuplicate, confirmStatus: this.state.confirmStatus, daysBeforeInterval: this.props.daysBeforeInterval, open: this.state.changePwOpen, handleChangePwClose: this.handleChangePwClose, handleInputBlur: this.handleInputBlur, form: this.form, handleFormSubmit: this.handleFormSubmit })),
            React.createElement(Hidden, { smDown: true },
                React.createElement(NavLink, { to: APP_PATH + "/homepage" },
                    React.createElement("img", { style: { height: '25px' }, src: Logo, alt: "" }))),
            React.createElement(Hidden, { mdUp: true },
                React.createElement(IconButton, { onClick: this.handleDrawerOpen, style: { color: 'white', padding: '3px' } },
                    React.createElement(MenuIcon, { fontSize: "large" }))),
            React.createElement("ul", { className: "top-nav" },
                React.createElement("li", { style: {
                        color: 'red',
                        fontWeight: 'bold',
                    } }, process.env.REACT_APP_TACT_TEST === 'ON' ? '測試環境' : ''),
                React.createElement("li", null,
                    React.createElement(NavLink, { to: APP_PATH + "/homepage", key: "1" },
                        React.createElement(IconButton, { style: { color: 'white', padding: '3px' } },
                            React.createElement(Tooltip, { title: "\u9996\u9801" },
                                React.createElement(HomeOutlinedIcon, { fontSize: "large" }))))),
                React.createElement("li", null,
                    React.createElement(ConnectionTime, null)),
                React.createElement("li", null,
                    React.createElement(NavLink, { to: window.sessionStorage.getItem('loginPage') || '/login', key: "4" },
                        React.createElement(IconButton, { onClick: this.handleClick, style: { color: 'white', padding: '3px' } },
                            React.createElement(Tooltip, { title: "\u767B\u51FA" },
                                React.createElement(ExitToAppOutlinedIcon, { fontSize: "large" }))))))));
    };
    return TitleandTool;
}(React.Component));
export { TitleandTool };
var mapStateToProps = function (state) { return ({
    username: getUserDataRedux(state).userName,
    drawerOpen: getDrawerOpen(state),
}); };
var mapDispatchToProps = function (dispatch) {
    var actions = {
        setDrawerOpen: setDrawerOpen,
    };
    return {
        actions: bindActionCreators(actions, dispatch),
        dispatch: dispatch,
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(withSnackbar(TitleandTool));
